"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSession = void 0;
const react_1 = require("next-auth/react");
const handle_token_refresh_error_1 = require("./handle-token-refresh-error");
const getSession = async (params) => {
    try {
        const { allowExpiredToken } = params ?? {};
        const session = await (0, react_1.getSession)(params);
        if (session && (0, handle_token_refresh_error_1.hasRefreshTokenError)(session)) {
            return (0, handle_token_refresh_error_1.handleTokenRefreshError)(session, allowExpiredToken);
        }
        return session;
    }
    catch (error) {
        // eslint-disable-next-line no-console
        console.warn(error);
        return null;
    }
};
exports.getSession = getSession;
